(function($){

    $(document).ready(function(){
        
        // Bookmark on same page

        $('a[href*="#"]:not([href="#"])').click(function(e) {

            if(this.hash == '#subscribeModal') { return; }

            if(location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
                
                var hash_target = $('[name=' + this.hash.slice(1) +']');
                var hash_target_string = '[name=' + this.hash.slice(1) + ']';

                if(hash_target.length) {
                    $('html,body').stop().animate({
                        scrollTop: hash_target.offset().top - 95
                    }, 'linear');
                }
            }

            $('#mobilemenuModal').modal('hide');
        });


    });

    $(window).on('load',function(){
        // Coming to bookmark from different page

        setTimeout(function(){
            var hash = window.location.hash;
        
            if ( hash == '' || hash == '#' || hash == undefined || hash == '#subscribeModal' ) return false;

            var hash_target = $('[name=' + hash.slice(1) +']');
            var hash_target_string = '[name=' + hash.slice(1) + ']';
     
            if (hash_target.length) {
                $('html,body').stop().animate({
                    scrollTop: hash_target.offset().top - 95 //offsets for fixed header
                }, 'ease-in');
            }
        }, 250);
    });
    
})(jQuery);
